<template>
    <div>
        <h1>진료보조 서비스 제공을 위한 건강정보(민감정보) 수집·이용 및 제3자 제공 동의</h1>
        주식회사 솔닥(이하 “회사”라 합니다)은 회원이 진료 과정에서 의료기관 또는 의료진에게 제공하기로 선택한 의료 마이데이터를 로컬 LLM을 통해 분석·요약·정리·가공하여, 의료진의 진료를 보조하기 위한 AI 기반 진료보조 서비스를 제공할 수 있습니다.<br>
        AI 기반 진료보조 서비스는 서비스 운영 방식에 따라 리포트형 요약, 주요 항목 정리, 진료 전 참고자료, 채팅형 질의·응답 등 다양한 형태로 제공될 수 있습니다.<br>
        회사는 AI 기반 진료보조 서비스 결과의 정확성, 완전성 또는 특정 의학적 판단 결과를 보증하지 않습니다.<br>
        의료진은 AI 기반 진료보조 서비스 결과를 참고자료로 활용할 수 있으며, 최종 진료 판단은 의료진의 책임과 전문적 판단에 따라 이루어집니다.<br>
        본 동의는 회원의 건강정보를 로컬 LLM으로 처리하여 AI 기반 진료보조 서비스를 제공하기 위해 필요한 동의입니다. 동의하지 않더라도 솔닥 건강정보 기본 조회 서비스 및 일반 진료 신청에는 제한이 없습니다. 다만, AI 기반 진료보조 기능은 이용할 수 없습니다.<br>
        <h2>진료보조 서비스 제공을 위한 건강정보(민감정보) 수집·이용 동의</h2>
        아래의 건강정보(민감정보) 수집·이용 내용을 확인하신 후 동의하여 주시기 바랍니다.<br>
        <h3>제1조 (수집 및 이용 목적)</h3>
        1. 회사는 회원이 해당 진료 건에서 의료기관 또는 의료진에게 제공하기로 선택한 의료 건강정보를 로컬 LLM으로 처리하여 의료진의 진료, 상담, 처방 등 의료서비스 제공을 보조하기 위한 참고자료를 생성하기 위한 목적으로 회원의 건강정보를 수집 및 이용합니다.<br>
        2. 회사는 본 동의에 따른 민감정보를 해당 진료 건의 AI 기반 진료보조 서비스 제공 목적 범위 내에서만 처리합니다.<br>
        3. AI 기반 진료보조 서비스의 결과는 의료진의 진료를 보조하기 위한 참고자료이며, 의료진의 진단, 처방, 치료 또는 의학적 판단을 대체하지 않습니다. 최종 진단 및 처방은 의료진의 판단에 따라 이루어집니다.<br>
        <h3>제2조 (수집 및 이용하는 건강정보 항목)</h3>
        1. 회사는 회원이 해당 진료 건에서 의료기관 또는 의료진에게 제공하기로 선택한 건강정보 중 AI 기반 진료보조 서비스 제공에 필요한 정보를 수집 및 이용할 수 있습니다.<br>
        2. 수집 및 이용 대상 민감정보 항목은 다음과 같습니다.<br>
        가. 의료 마이데이터: 진료이력, 진단내역, 처방내역, 투약이력, 건강검진정보, 암검진정보, 예방접종정보, 진단검사·기타검사·영상검사·병리검사 결과, 수술 및 처치내역, 알레르기 및 불내성 정보, 부작용 정보<br>
        나. 솔닥 진료데이터: 솔닥 서비스에서 진료본 내역(처방내역)<br>
        3. 회사는 회원이 해당 진료 건에서 제공에 동의하지 않은 의료 건강정보를 AI 기반 진료보조 서비스 제공 목적으로 처리하지 않습니다.<br>
        <h3>제3조 (AI 처리 방식)</h3>
        1. 회사는 본 동의에 따라 수집한 회원의 의료 건강정보를 회사 내부 인프라에서 운영되는 로컬 LLM을 통해 처리합니다.<br>
        2. 회사는 본 동의를 근거로 회원의 건강정보, AI 기반 진료보조 서비스 결과, 입력 내용 및 응답 결과를 AI 모델 학습 목적으로 사용하지 않습니다.<br>
        <h3>제4조 (열람 및 이용기간)</h3>
        1. 회사는 본 동의에 따라 처리하는 건강정보 및 AI 기반 진료보조 서비스 결과를 해당 진료 건의 AI 기반 진료보조 서비스 제공을 위해 열람·이용합니다.<br>
        2. 건강정보 및 AI 기반 진료보조 서비스 결과는 진료 예약 시점부터 처방전 사용기간 만료일까지 열람할 수 있습니다. 처방전이 발급되지 않은 경우에는 해당 의료기관이 정한 열람기간까지 열람할 수 있으며, 해당 기간이 종료되면 의료기관 또는 의료진에게 더 이상 노출되지 않습니다.<br>
        3. 해당 진료가 취소된 경우에는 열람기간이 남아 있더라도 의료기관 또는 의료진에게 건강정보 및 AI 기반 진료보조 서비스 결과가 더 이상 노출되지 않습니다.<br>
        4. 회원이 본 동의 또는 해당 진료 건에 대한 건강정보 제공 동의를 철회하거나, 건강정보 연동 해지·회원 탈퇴 등으로 회사가 해당 정보를 더 이상 처리할 수 없는 경우 회사는 AI 기반 진료보조 서비스 제공 및 의료기관 또는 의료진의 열람을 중단합니다.<br>
        5. 회사는 관계 법령 또는 서비스 운영상 필요한 경우 AI 기반 진료보조 서비스의 이용 이력, 생성 이력, 제공 이력 등 필요한 정보를 관계 법령 및 회사의 개인정보 처리 기준에 따라 보관·관리할 수 있습니다.<br>
        6. 의료진이 건강정보 및 AI 기반 진료보조 서비스 결과를 참고하여 별도로 작성한 진료기록, 소견, 처방 등은 관계 법령에 따른 진료기록 보존 기준에 따라 보관될 수 있습니다. 다만, 회사가 제공한 원본 건강정보 및 AI 기반 진료보조 서비스 결과 자체는 의료기관 또는 의료진의 시스템에 별도로 저장되지 않습니다.<br>
        <h3>제5조 (동의 거부·철회 및 제공 후 처리)</h3>
        1. 회원은 본 동의를 거부하거나 철회할 수 있습니다.<br>
        2. 회원이 본 동의를 거부하거나 철회하더라도 솔닥 건강정보 기본 조회 서비스 및 일반 진료 신청에는 제한이 없습니다. 다만, AI 기반 진료보조 기능은 이용할 수 없습니다.<br>
        3. 회원이 본 동의를 철회하는 경우 회사는 해당 진료 건에 대한 AI 기반 진료보조 서비스 제공을 중단합니다.<br>
        <h2>진료보조 서비스 제공을 위한 건강정보(민감정보) 제3자 제공 동의</h2>
        아래의 건강정보(민감정보) 제3자 제공 내용을 확인하신 후 동의하여 주시기 바랍니다.<br>
        <h3>제1조 (제3자 제공 목적)</h3>
        1. 회사는 회원이 해당 진료 건에서 의료기관 또는 의료진에게 제공하기로 선택한 의료 건강정보를 로컬 LLM으로 처리하여 생성된 참고자료를 의료진의 진료, 상담, 처방 등 의료서비스 제공을 보조하기 위한 목적으로 제공합니다.<br>
        2. 회사는 본 동의에 따라 생성된 결과를 AI 기반 진료보조 리포트, 요약·분류·정리 정보, 질의·응답 결과 등 의료진의 진료 참고를 위한 다양한 형태로 제공할 수 있습니다.<br>
        3. 회사는 본 동의에 따라 생성된 정보를 해당 진료 건의 진료보조 목적 범위 내에서만 제공합니다.<br>
        4. AI 기반 진료보조 서비스의 결과는 의료진의 진료를 보조하기 위한 참고자료이며, 의료진의 진단, 처방, 치료 또는 의학적 판단을 대체하지 않습니다. 최종 진단 및 처방은 의료진의 판단에 따라 이루어집니다.<br>
        5. 회사는 해당 정보를 의료기관 또는 의료진이 해당 진료 건의 진료 과정에서 참고할 수 있도록 열람 형태로 제공하며, 원본 의료 건강정보 및 이를 기반으로 생성된 AI 기반 진료보조 서비스 결과를 의료기관 또는 의료진의 시스템에 별도로 저장하지 않습니다.<br>
        <h3>제2조 (제공되는 건강정보 항목)</h3>
        1. 회사는 본 동의에 따라 회원의 건강정보를 로컬 LLM으로 처리하여 생성한 AI 기반 진료보조 리포트, 요약·분류·정리 정보, 질의·응답 결과 등 의료진의 진료 참고를 위한 자료를 해당 진료 건에서 회원이 선택한 의료기관 또는 의료진에게 제공할 수 있습니다.<br>
        2. 의료기관 또는 의료진에게 제공되는 참고자료에 포함되는 민감정보 항목은 다음과 같습니다.<br>
        가. 의료 마이데이터: 진료이력, 진단내역, 처방내역, 투약이력, 건강검진정보, 암검진정보, 예방접종정보, 진단검사·기타검사·영상검사·병리검사 결과, 수술 및 처치내역, 알레르기 및 불내성 정보, 부작용 정보<br>
        나. 솔닥 진료데이터: 솔닥 서비스에서 진료본 내역(처방내역)<br>
        3. 회사는 회원이 해당 진료 건에서 제공에 동의하지 않은 의료 건강정보를 AI 기반 진료보조 서비스 제공 목적으로 처리하지 않습니다.<br>
        <h3>제3조 (AI 기반 진료보조 서비스의 내용)</h3>
        1. 회사는 회원의 의료 마이데이터를 로컬 LLM으로 처리하여 의료진이 진료 과정에서 참고할 수 있는 정보를 생성·제공할 수 있습니다.<br>
        2. AI 기반 진료보조 서비스는 서비스 운영 방식에 따라 리포트형 요약, 주요 항목 정리, 진료 전 참고자료, 채팅형 질의·응답 등 다양한 형태로 제공될 수 있습니다.<br>
        3. 회사는 AI 기반 진료보조 서비스 결과의 정확성, 완전성 또는 특정 의학적 판단 결과를 보증하지 않습니다.<br>
        4. 의료진은 AI 기반 진료보조 서비스 결과를 참고자료로 활용할 수 있으며, 최종 진료 판단은 의료진의 책임과 전문적 판단에 따라 이루어집니다.<br>
        <h3>제4조 (AI 처리 방식)</h3>
        1. 회사는 본 동의에 따라 회원의 의료 건강정보를 회사 내부 인프라에서 운영되는 로컬 LLM을 통해 처리합니다.<br>
        2. 회사는 본 동의를 근거로 회원의 건강정보, AI 기반 진료보조 서비스 결과, 입력 내용 및 응답 결과를 AI 모델 학습 목적으로 사용하지 않습니다.<br>
        <h3>제5조 (제공받는 자)</h3>
        1. 제공받는 자는 회원이 진료 예약, 진료 접수 또는 진료 신청 과정에서 선택한 의료기관 또는 의료진입니다.<br>
        2. 제공받는 자의 구체적인 명칭은 AI 기반 진료보조 서비스 동의 화면 또는 진료 예약·접수 화면에서 확인할 수 있습니다.<br>
        3. 의료기관 또는 의료진이 솔닥 EMR 등 회사가 제공하는 의료진용 서비스를 통해 AI 기반 진료보조 서비스 결과를 열람하는 경우에도, 해당 의료기관 또는 의료진은 진료 목적의 독립적인 개인정보처리자로서 해당 정보를 제공받는 것으로 볼 수 있습니다. 이 경우 의료기관 또는 의료진은 해당 진료 건의 진료 목적으로 정보를 열람할 수 있으며, 회사가 제공하는 원본 의료 건강정보 및 AI 기반 진료보조 서비스 결과 자체는 의료기관 또는 의료진의 시스템에 별도로 저장되지 않습니다.<br>
        <h3>제6조 (열람 및 이용기간)</h3>
        1. 제공받는 자는 회원이 선택한 해당 진료 건의 진료, 상담, 처방 등 의료서비스 제공을 위하여 원본 의료 건강정보 및 AI 기반 진료보조 서비스 결과를 열람·이용할 수 있습니다.<br>
        2. 원본 의료 건강정보 및 AI 기반 진료보조 서비스 결과는 진료 예약 시점부터 처방전 사용기간 만료일까지 열람할 수 있습니다. 처방전이 발급되지 않은 경우에는 해당 의료기관이 정한 열람기간까지 열람할 수 있으며, 해당 기간이 종료되면 의료기관 또는 의료진에게 더 이상 노출되지 않습니다.<br>
        3. 회사가 제공하는 원본 의료 건강정보 및 AI 기반 진료보조 서비스 결과는 의료기관 또는 의료진의 시스템에 별도로 저장되지 않으며, 회사가 정한 열람 가능 기간 또는 해당 진료 건의 진료 목적 달성 시까지 열람할 수 있습니다.<br>
        4. 다만, 의료진이 해당 정보를 진료 과정에서 참고하여 별도로 작성한 진료기록, 소견, 처방 등은 의료기관이 생성한 별도의 진료기록으로서 관계 법령에 따른 보존기간 동안 보관될 수 있습니다.<br>
        <h3>제7조 (동의 거부·철회 및 제공 후 처리)</h3>
        1. 회원은 본 동의를 거부하거나, AI 기반 진료보조 서비스 결과가 의료기관 또는 의료진에게 제공되기 전까지 철회할 수 있습니다.<br>
        2. 회원이 본 동의를 거부하거나 철회하더라도 솔닥 건강정보 기본 조회 서비스 및 일반 진료 신청에는 제한이 없습니다. 다만, AI 기반 진료보조 기능은 이용할 수 없습니다.<br>
        3. 회원이 본 동의를 철회하는 경우 회사는 해당 진료 건에 대한 AI 기반 진료보조 서비스 제공을 중단합니다.<br>
        4. 회원이 동의를 철회하는 경우 회사는 해당 진료 건에 대한 AI 기반 진료보조 서비스 제공 및 의료기관 또는 의료진의 추가 열람을 중단합니다.<br>
        5. 동의 철회 전에 의료기관 또는 의료진이 이미 열람한 정보에 대해서는 과거의 열람 사실을 취소할 수 없습니다. 다만, 회사가 제공한 원본 의료 건강정보 및 AI 기반 진료보조 서비스 결과 자체는 의료기관 또는 의료진의 시스템에 별도로 저장되지 않습니다.<br>
        6. 의료진이 해당 정보를 참고하여 별도로 작성한 진료기록, 소견, 처방 등은 관계 법령 및 해당 의료기관의 개인정보 처리 기준에 따라 보관될 수 있습니다.
    </div>
</template>

<script>
export default {
    name: 'mydataAiAssist'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/mydata/AiAssist.vue